const BIKES = [
  "Honda Activa",
  "Suzuki Access 125",
  "TVS Jupiter",
  "Royal Enfield Classic 350",
  "Royal Enfield Himalayan",
  "Royal Enfield Interceptor 650",
  "KTM 390 Adventure",
  "Triumph Speed 400",
  "Kawasaki Ninja 650",
  "BMW G 310 GS",
  "Ducati Scrambler 800",
  "Kawasaki Z900",
  "Harley-Davidson Iron 883",
  "Ducati Panigale V2",
  "BMW S 1000 RR",
];

export const FleetMarquee = () => {
  const items = [...BIKES, ...BIKES];

  return (
    <section
      id="fleet"
      data-testid="fleet-marquee"
      className="relative bg-[#1e2528] border-y border-[#3e4b55]/50 py-10 md:py-12 overflow-hidden scroll-mt-24 md:scroll-mt-28"
    >
      <div className="flex whitespace-nowrap animate-[marquee_60s_linear_infinite]">
        {items.map((bike, idx) => (
          <div
            key={`${bike}-${idx}`}
            className="flex items-center gap-10 mx-10 text-2xl md:text-4xl lg:text-5xl font-display uppercase tracking-wide"
          >
            <span className="text-[#f7f7f7]">{bike}</span>
            <span className="text-[#e89b1f] text-3xl md:text-5xl leading-none">
              ✦
            </span>
          </div>
        ))}
      </div>

      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @media (prefers-reduced-motion: reduce) {
          [data-testid="fleet-marquee"] > div {
            animation: none !important;
          }
        }
      `}</style>
    </section>
  );
};
